var map = {
	"./custom/app/navbar/navbar.component": [
		91619,
		[
			"src_themes_custom_app_navbar_navbar_component_ts"
		]
	],
	"./dspace/app/navbar/navbar.component": [
		44570,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19318;
module.exports = webpackAsyncContext;